<template>

  <!-- id="eagleMapContainer"  @scroll="hanldeScroll" -->
  <div>

    <div class="search_box">
      <div class="search_left">
        <img class="search_icon" src="/static/sousuoicon.png"></img>
        <input class="search_input" placeholder="请输入您要搜索的商品" v-model="inputkeyword"></input>
      </div>
      <div class="search_text" @click="search()">搜索</div>
    </div>
    <!--    <van-tabs>
      <van-tab v-for="(item,index) in tabClass" :title="item.name" :key="index">

      </van-tab>
    </van-tabs> -->

    <!--  id="table_list" -->
    <!--  :on-refresh="refresh" -->
    <scroller :on-infinite="infinite">
      <div class="index_projectList">
        <div class="index_projectbox" v-for="(item,index) in productList" @click="toproDetail(item.id)">
          <div class="index_portop">
            <img class="inde_porimg" :src="item.thumb" />
          </div>
          <div class="index_probottom">
            <div class="index_title">
              {{item.name}}
            </div>
            <div class="index_price">
              <span class="index_moneytip">￥</span>
              {{item.price}}
            </div>
          </div>
        </div>
      </div>
      <div class="none"></div>
    </scroller>

    <!--  <van-tabs active="tabClass">
      <van-tab title="标签 1">内容 1</van-tab>
      <van-tab title="标签 2">内容 2</van-tab>
      <van-tab title="标签 3">内容 3</van-tab>
      <van-tab title="标签 4">内容 4</van-tab>
      <van-tab title="标签 5">内容 5</van-tab>
      <van-tab title="标签 6">内容 6</van-tab>
    </van-tabs> -->
    <!-- <div class="index_bianjiecenter">
        <img src="/static/haohuo.png" class="index_quanxiangimgtitle" />
      </div> -->
    <!-- <div v-if="datalengthX" class="more" @click="getMore()">查看更多</div>
      <div class="none"></div> -->

  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        projectList: [],
        productList: [],
        inputkeyword: "",
        tabClass: [{
          name: "推荐"
        }, {
          name: "汽车用品"
        }, {
          name: "生活用品"
        }, {
          name: "潮流服饰"
        }, {
          name: "吃货星球"
        }],
        datalengthX: false,
        pages: 1,
        loading: false,
      }
    },
    created() {
      //this.request("getproductList")
      this.request("getproductList", {
        page: this.pages,
        page_size: 20
      })
    },
    mounted() {
      //window.addEventListener("scroll", this.hanldeScroll, true);
    },
    methods: {
      refresh() {
        // if (that.datalengthX) {
        //   let page = (that.pages) + 1
        //   that.pages = page
        //   this.request("getproductList", {
        //     page: that.pages,
        //     page_size: 20
        //   })
        // }else{

        // }
        // setTimeout(() => {
        //   let start = this.top - 1

        //   for (let i = start; i > start - 10; i--) {
        //     this.items.splice(0, 0, i + ' - keep walking, be 2 with you.')
        //   }

        //   this.top = this.top - 10;

        //   done()
        // }, 1500)
        console.log(123)
      },
      infinite(done) {
        let that = this
        setTimeout(function() {
          if (that.datalengthX) {
            let page = (that.pages) + 1
            that.pages = page
            that.request("getproductList", {
              page: that.pages,
              page_size: 20
            })
          }
          done(456)
        }, 1000)

      },
      //跳转商品详情页
      toproDetail(index) {
        let that = this
        let id = index
        that.$router.push({
          path: "/projectDetail",
          query: {
            id: id
          }

        })
      },
      //搜索
      search() {
        let that = this
        that.pages = 1
        that.productList = []
        if (this.inputkeyword) {
          that.request("getproductList", {
            keyword: this.inputkeyword,
            page: this.pages,
            page_size: 20
          })
        } else {
          that.request("getproductList", {
            page: this.pages,
            page_size: 20
          })
        }

      },
      // 调用接口
      request(type = '', requestData = {}) {
        //根据source获取客服电话
        let that = this
        switch (type) {
          //获取商品信息
          case 'getproductList':
            httper.post('product/mall-product-list', requestData, res => {
              if (res.code == 0) {
                let lengthX = res.data.length - 20 == 0
                that.datalengthX = lengthX
                // that.list = [...this.list, ...res.data] //数据拼接,
                console.log("res", res)
                if (res.data.length > 0) {
                  let list = that.productList;
                  for (let i = 0; i < res.data.length; i++) {
                    list.push(res.data[i]);
                  }
                  that.productList = list
                }
                // this.productList = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, false)
            break
        }
      },
      // hanldeScroll(e) {
      //   // 获取eagleMapContainer的真实高度
      //   const boxHeight = document.getElementById('eagleMapContainer').offsetHeight;
      //   // 获取table_list的真实高度（浮动内容的真实高度）
      //   console.log("boxHeight", boxHeight)
      //   const tableHeight = document.getElementById('table_list').offsetHeight;
      //   console.log("tableHeight", tableHeight)
      //   // boxHeight和滑块浮动的高度相差小于50 && 不在加载中 && 不是最后一页
      //   if (tableHeight - (e.target.scrollTop + boxHeight) < 50 && !this.loading) {
      //     // 这里触发加载请求
      //     // this.page = this.page + 1;
      //     // this.getWorkOrder();
      //     let page = (that.pages) + 1
      //     that.pages = page
      //     this.request("getproductList", {
      //       page: that.pages,
      //       page_size: 20
      //     })
      //   }
      // },
      //查看更多
      getMore() {
        let that = this
        if (that.datalengthX) {
          let page = (that.pages) + 1
          that.pages = page
          this.request("getproductList", {
            page: that.pages,
            page_size: 20
          })
        } else {
          that.$toast({
            message: '没有更多了'
          })
          this.datalengthX = false
        }
        //that.changeNavIndex(that.navIndex, page, false)
      },
    }
  }
</script>

<style scoped="scoped">
  /* body {
    background-color: #F7F7F7 !important;
  } */

  .index_projectList {
    width: calc(100% - 40px);
    margin: 10px 20px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    margin-top: 65px;
  }

  .index_projectbox {
    /* border: 1px solid rgba(210,210,210,1); */
    width: 43%;
    /* margin: 10px; */
    margin: 13px 3%;
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
  }

  .index_portop {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #D2D2D2;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .inde_porimg {
    width: 100%;
    height: 100%;
  }

  .index_probottom {
    background-color: #fff;
    padding: 10px 5px;
  }

  .index_title {
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  .index_hot {
    width: 23px;
    height: 12px;
    background: linear-gradient(90deg, rgba(6, 195, 97, 1) 0%, rgba(2, 226, 111, 1) 100%);
    font-size: 8px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .index_price {
    font-size: 19px;
    color: #EA6E56;
    display: flex;
    align-items: center;
  }

  .index_moneytip {
    font-size: 12px;
    /* margin-right: 5px; */
  }

  .search_box {
    width: 100%;
    height: 35px;
    background-color: #fff;
    /* box-shadow:0px 5px 7px 2px rgba(187,187,187,0.3); */
    border-bottom: 1px solid #D2D2D2;
    /*   margin-top: 1px; */
    padding: 10px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2;
  }

  .search_left {
    width: 85%;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: #EEEEEE;
    border-radius: 25px;
  }

  .search_icon {
    width: 15px;
    height: 15px;
    margin: 0 10px;
  }

  .search_input {
    border: none;
    font-size: 12px;
    /* width: 100%; */
    width: 87%;
    background-color: inherit;
  }

  .search_text {
    font-size: 12px;
    margin-left: 5px;
  }

  .index_bianjiecenter {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 10px 0;
  }

  .index_quanxiangimgtitle {
    width: 220px;
    height: 35px;
  }

  .van-tabs__line {
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 1;
    height: 3px;

    background: #FD8C00;
    border-radius: 3px;
  }

  .more {
    font-size: 14px;
    margin: 10px;
    text-align: center;
  }

  .none {
    width: 100%;
    height: 30px;
  }

  ._v-container[data-v-ecaca2b0] {
    top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/productList.vue